import React from 'react';
import Ajv, { ValidateFunction } from 'ajv';
import { parse as yamlParse } from 'yaml';
import styles from './yaml-editor/yamlEditor.module.scss';

const validatorCache = new WeakMap<object, ValidateFunction>();

export function getJsonSchemaErrorString(schema: any, data: any): string | null {
  let validate = validatorCache.get(schema);

  if (!validate) {
    const ajv = new Ajv({ allowUnionTypes: true });
    validate = ajv.compile(schema);
    validatorCache.set(schema, validate);
  }
  if (!validate(data)) {
    return validate
      .errors!.map((error) => {
        let errorString = error.message;
        errorString += `\nPATH: ${error.instancePath}`;
        if (error.keyword == 'additionalProperties')
          errorString += `\nADDITIONAL PROPERTY: ${error.params.additionalProperty}`;
        if (error.keyword == 'const') errorString += `\nALLOWED VALUE: ${error.params.allowedValue}`;
        return errorString;
      })
      .join('\n\n');
  }

  return null;
}

export function verifyYaml(yamlContent: string, yamlSchema?: any) {
  try {
    const yamlContentParsed = yamlParse(yamlContent);
    if (yamlSchema) {
      const errorString = getJsonSchemaErrorString(yamlSchema, yamlContentParsed);
      if (errorString) throw new SyntaxError(errorString);
    }
  } catch (error) {
    const lines = String(error).split('\n');
    return (
      <div className={styles.yamlVerificationErrorMessage}>
        {lines.map((line, idx) => (
          <React.Fragment key={`L${idx}`}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </div>
    );
  }
  return null;
}
